import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {TextField} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {editPreset, deletePreset} from "../../../store/filterSlice";

const EditPreset = (props) => {
	const [name, setName] = useState(props.preset.name);
	const [filters, setFilters] = useState(props.preset.filters);

	const onClickSave = () => {
		console.log("Saving ", name, filters);
		props.editPreset({...props.preset, name, filters});
		props.onClose();
	};

	const onClickDelete = () => {
		props.deletePreset(props.preset.filter_id);
		props.onClose();
	};

	const updateFiltersButton = filters === JSON.stringify(props.filter) ? null :
		<div style={{marginTop: 15}}>Overwrite the saved filters with current ones? <Button onClick={() => setFilters(JSON.stringify(props.filter))} size='sm' variant='contained'>Replace Filters</Button></div>;

	return (<Dialog	open={true}>
			<DialogTitle id="alert-dialog-title">Editing Preset</DialogTitle>
			<DialogContent>
				<TextField label='Preset Name' value={name} onChange={(e) => setName(e.target.value)} autoFocus />
				{updateFiltersButton}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => props.onClose()}>
					Cancel
				</Button>
				<Button onClick={onClickDelete} color="secondary">
					Delete
				</Button>
				<Button onClick={onClickSave} color="primary">
					Save
				</Button>
			</DialogActions>
		</Dialog>	);
};

EditPreset.propTypes = {
	preset: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
	return {
		filter: state.filter
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		deletePreset: (presetId) => dispatch(deletePreset(presetId)),
		editPreset: (preset) => dispatch(editPreset(preset)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPreset);